import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Solicitud_actividad } from './../expand/Solicitud_actividad';
import BootstrapTable from 'react-bootstrap-table-next';
import { Col, Row, Container } from 'react-bootstrap';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import crear from './../../img/svg/Nueva.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'


//Funcion para colocar color a las headers la tabla
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}

function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '10%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

export class Tabla_Actividades extends Component {
    static displayName = Tabla_Actividades.name;

    constructor(props) {
        super(props);
        this.state = {
            solicitudes: [], accion: "", loading: false, loading2: false,            
            actividades: [], solicitudes: [], busqueda: "", solicitudes: [], actividad: {
                idactividad: 0, actividad: "", tipoactividad: "", descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: "", idUnico: ""
            }, anio: props.anio,
            fila: [], fila_mat: [], actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], expanded: [], expanded_mat: [], valida_next: false
        };

        this.closeExpandxId = this.closeExpandxId.bind(this);
    }

    componentDidMount() {
        this.setState({
            actividades: this.props.actividades,
            anio: this.props.anio,
            tipoactividad: this.props.tipoactividad,
        }, () => {

            // AGREGAR ACTIVIDADES VALIDADAS EN 1S
            //console.log("actividades " + this.props.tipoactividad + ": ", this.props.actividades);
            if (this.props.terminoPeriodo === "2S") {

                var checkSin = undefined;

                if (this.props.actividades.length > 0) {
                    checkSin = document.getElementById("Actividades_" + this.props.tipoactividad).getElementsByClassName('form-check-input');
                    //console.log("checkSin " + this.props.tipoactividad + ": ", checkSin);
                    //console.log("checkSin " + this.props.tipoactividad + " length: ", checkSin.length);
                }

                this.props.actividades.map((item, index) => {
                    if (item.termino1 === "1" || item.termino3 === "0") {
                        //console.log("termino != 2S: ", item);

                        if (this.props.actividades.length > 0) {
                            //var checkNeeded = checkSin["ch1_" + item.idUnico];
                            //checkNeeded.checked = true;
                        }

                        this.state.fila.push({
                            idUnico: item.idUnico,
                            validacion: 'si'
                        });
                    }
                });
                this.props.setconteo_final(this.state.fila);
            }
        });
    }

    /////FUNCIONES para interactuar los expand ACtividades
    closeExpandxId(idactividad) {
        if (this.state.expanded.includes(idactividad)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idactividad)
            }));
        }
    }
    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    /////FUNCIONES para interactuar con los si/no de ACtividades
    handleHideClick = (idactividad) => {
        const check = document.getElementsByName("all_" +this.props.tipoactividad);
        check[0].checked = false;
        check[1].checked = false; 
        
        let obj = this.state.fila.find((o, i) => {
            if (o.idUnico === idactividad) {
                if (this.state.fila[i].validacion === 'no') {  
                        this.state.fila[i].validacion = 'si'
                        return this.state.fila[i]; 

                }
            }
        }); 
        if (obj == null) {   
            this.state.fila.push({
                idUnico: idactividad,
                validacion: 'si'
            })
        } else { 
            this.mensaje_afirma(idactividad)
        }
        this.props.setconteo_final(this.state.fila);
    }

    handleShowClick = (idactividad) => {

        const check = document.getElementsByName("all_" + this.props.tipoactividad);
        check[0].checked = false;
        check[1].checked = false;
        //console.log(idactividad)
        if (!this.state.expanded.includes(idactividad)) {

            let obj = this.state.fila.find((o, i) => {
                if (o.idUnico === idactividad) {
                    this.state.fila[i].validacion = 'no'
                    return this.state.fila[i];
                }
            });
            if (obj == null) {
                this.state.fila.push({
                    idUnico: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded: [...this.state.expanded, idactividad]
            }));
        }
        //console.log(this.state.fila);
        if (!this.props.valida_next) {
            this.isValidated_all( this.state.fila.length);
        }

        this.props.setconteo_final(this.state.fila)
    }

    handleHideAllClick = () => {

        let filas = [];

        this.props.actividades.forEach((element) => {
            // COMENTADO SBRODRIG
            //filas.push({
            //    idactividad: element.idUnico,
            //    validacion: 'si'
            //});

            filas.push({
                idUnico: element.idUnico,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded: [],
            fila: filas
        }));

        this.props.setconteo_final(filas);
        this.handleAllCheck();
    }

    handleShowAllClick = () => {

        let filas = [];
        let expandir = [];

        if (this.props.terminoPeriodo === "2S") {
            this.props.actividades.forEach((element) => {
                if (element.termino2 === "2") {
                    filas.push({
                        idUnico: element.idUnico,
                        validacion: 'no'
                    });
                    if (!this.state.expanded.includes(element.idUnico)) {
                        expandir.push(element.idUnico);
                    }
                } else {
                    filas.push({
                        idUnico: element.idUnico,
                        validacion: 'si'
                    });
                }
            });
        } else {
            this.props.actividades.forEach((element) => {
                filas.push({
                    idUnico: element.idUnico,
                    validacion: 'no'
                });
                if (!this.state.expanded.includes(element.idUnico)) {
                    expandir.push(element.idUnico);
                }
            });
        }
        
        this.setState(() => ({
            expanded: this.state.expanded.concat(expandir),
            fila: filas
        }));
        this.props.setconteo_final(filas);
        this.handleAllCheck();
    }

    isValidated_all(tam, tam2) {
        //seteando la fila en el padre
        this.props.setfila(tam2);

    }

    handleAllCheck() {
        const check = document.getElementsByName("all_" + this.props.tipoactividad );
        const checkSin = document.getElementById("Actividades_" + this.props.tipoactividad ).getElementsByClassName('form-check-input');
        
        if (check[0].checked) {
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "1" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}

                } else {
                    if (checkSin[i].value === "1") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1
            
            if (!this.props.valida_next) {
                this.isValidated_all( chec);
            }

        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "0" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "0") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1;

            if (!this.props.valida_next) {
                this.isValidated_all( chec);
            }
        }
    }

    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }

    mensaje_afirma(idactividad) {

        Swal.fire({
            title: '¿Está seguro de cambiar?',
            text: "Usted podría perder la selección y los datos ingresados de esta observación",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cambiar selección.',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                if (this.state.expanded.includes(idactividad)) {
                    this.setState(() => ({
                        expanded: this.state.expanded.filter(x => x !== idactividad)
                    }));
                }

                this.props.setSolicitudes(0, idactividad)
            } else {

                let obj = this.state.fila.find((o, i) => {
                    if (o.idUnico === idactividad) {
                            this.state.fila[i].validacion = 'no'
                            return this.state.fila[i];  
                    }
                });
                const checksi = document.getElementById("ch1_" + idactividad);
                const checkno = document.getElementById("ch2_" + idactividad);
                //console.log('NO de mensaje afirma')
                checksi.checked = false;
                checkno.checked = true; 
            }
        })
    }
    render() {
     


        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        };
        const columns_acti = [
            {
                dataField: 'id',
                text: '#',

                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: '',
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'idActividad',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'actividad',
                text: 'Actividad',
                headerStyle: color_head_desc('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Descripción',
                headerStyle: color_head_desc('a'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'termino',
                text: 'Periodo',
                formatter: (cellContent, row) => {
                    if (row.termino2 == "2" && row.termino1 == "1" && row.termino3 == "0") {
                        return (
                            <> PAE {row.anio}<br />PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                        )
                    }
                    else if (row.termino1 == "1") {
                        if (row.termino1 == "1" && row.termino3 == "0") {
                            return (
                                <>PAO {row.anio}-1<br /> PAE {row.anio}</>
                            );
                        } else if (row.termino2 == "2" && row.termino1 == "1") {
                            return (
                                <>PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                            );
                        } else {
                            return (
                                <>PAO {row.anio}-1</>
                            );
                        }
                    } else if (row.termino2 == "2") {
                        if (row.termino2 == "2" && row.termino1 == "1") {
                            return (
                                <>PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                            );

                        } else if (row.termino2 == "2" && row.termino3 == "0") {
                            return (
                                <>PAO {row.anio}-2<br /> PAE {row.anio}</>
                            );
                        }
                        return (
                            <>PAO {row.anio}-2</>
                        );
                    } else if (row.termino3 == "0") {
                        if (row.termino3 == "0" && row.termino1 == "1") {
                            return (
                                <>PAE {row.anio}<br /> PAO {row.anio}-1</>
                            );

                        } else if (row.termino3 == "0" && row.termino2 == "2") {
                            return (
                                <>PAE {row.anio}<br /> PAO {row.anio}-2</>
                            );
                        }
                        return (
                            <>PAE {row.anio}</>
                        );
                    }
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: 'Subtotal:'
            }, {
                dataField: 'totalHoras',
                text: 'Horas',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footerAlign: 'left',
                footer: columnData => {
                    //const total2 = columnData.reduce((acc, item) => (Number(acc) + Number(item)).toFixed(2), 0);
                    const total2 = columnData.reduce((acc, item) => (Number(acc) + Number(item)), 0);
                    return (<>{total2.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
                },


            }, {
                dataField: 'tipoActividad',
                text: 'tipoactividad',
                hidden: true


            },
            {
                dataField: 'conformidad',
                text: 'Validada',
                isDummyField: true,
                headerFormatter: (column, colIndex) => {
                    return (
                        <div className="text-validada-center">
                            Validar<br />Seleccionar todo<label className="asterisco">*</label>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" name={"all_" +this.props.tipoactividad}  value="1" type="radio" onChange={this.handleHideAllClick} />Si&nbsp;
                                    <input className="form-check-input" name={"all_" + this.props.tipoactividad} value="0" type="radio" onChange={this.handleShowAllClick} />No

                                 </div>
                        </div>

                    )
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" id={"ch1_" + row.idUnico} name={this.props.tipoactividad + rowIndex} value="1" type="radio" onChange={() => this.handleHideClick(row.idUnico)} disabled={this.props.terminoPeriodo === "2S" && row.termino2 === null} />Si&nbsp;&nbsp;
                                <input className="form-check-input" id={"ch2_" + row.idUnico} name={this.props.tipoactividad + rowIndex} value="0" type="radio" onChange={() => this.handleShowClick(row.idUnico, rowIndex)} disabled={this.props.terminoPeriodo === "2S" && row.termino2 === null} />No
                            </div>
                        </div>

                    );
                    // BLOQUEAR PAE en PAO1: disabled={(this.props.terminoPeriodo === "1S" && row.termino3 === "0") || (this.props.terminoPeriodo === "2S" && row.termino2 === null)}
                    //disabled={this.props.terminoPeriodo === "2S" && (row.termino1 === "1" || row.termino3 === "0")}
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                }
            }];
        const expandRow = {
            onlyOneExpanding: true,
            expanded: this.state.expanded,
            expandByColumnOnly: true,
            renderer: (row, rowIndex) => (
                <div>
                    <Solicitud_actividad rowIndex={rowIndex} idactividad={row.idActividad} idUnico={row.idUnico} descripcion={row.descripcion} totalhoras={row.totalHoras} anio={row.anio} tipoactividad={row.tipoActividad} termino={row.termino} termino1={row.termino1} termino2={row.termino2} termino3={row.termino3} updatestate={this.props.updatestate} closeExpandxId={this.closeExpandxId} />
                </div>
            )
        };

        return (
            <div> 
               
                { this.props.actividades && this.props.actividades.length > 0 ?
                    <>
                     <button style={buttonToLink} onClick={() => this.props.toggle()}><img className="new-logo" src={crear} />Nueva Actividad</button>
                    <BootstrapTable
                        id={"Actividades_" +this.props.tipoactividad }
                        keyField='idUnico'
                        data={this.props.actividades}
                        columns={columns_acti}
                        bordered={false}
                        expandRow={expandRow}
                    /></> : null
                }                           
            </div>
        );
    }


}
